// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"A6","hidden":"A7","menuBackground":"A8","avatar":"A9","header":"A-","accountNavAvatar":"A_","buttonPlaceholder":"Ba","accountLinks":"Bb","accountLink":"Bc"};